import { setEditor } from 'reactApp/modules/editor/editor.saga';
import { watchFreezeUser } from 'reactApp/modules/freeze/freeze.saga';
import { setTree } from 'reactApp/modules/home/home.saga';
import { initMyTeam } from 'reactApp/modules/myTeam/myTeam.saga';
import { watchAskPhone } from 'reactApp/modules/recovery/askPhone.saga';
import { initConsoleApi, reportFeatures, setQueryParams } from 'reactApp/modules/settings/settings.saga';
import { socialUserConfirmEmail } from 'reactApp/modules/socialUser/socialUser.saga';
import { initSortSaga } from 'reactApp/modules/sort/sort.saga';
import { checkContinueUpload } from 'reactApp/modules/uploadList/continueUpload/continueUpload.saga';
import { renderMobileLeftMenu } from 'reactApp/ui/Mobile/LeftMenu/LeftMenu.helpers';
import { call, fork, select } from 'redux-saga/effects';

import { EnvironmentSelectors } from '../environment/environment';
import { SettingsSelectors } from '../settings/settings.selectors';

export function* initSagas() {
    yield fork(watchAskPhone);
    yield fork(watchFreezeUser);
    yield call(setQueryParams);
    yield fork(setEditor);
    yield call(setTree);
    yield call(initSortSaga); // TODO: routing: now it is for home only
    yield call(checkContinueUpload);
    yield fork(socialUserConfirmEmail);
    yield call(initConsoleApi);
    yield call(reportFeatures);
    yield call(initMyTeam);

    const { action: queryParam } = yield select(SettingsSelectors.getQueryParams);
    const isPhone = yield select(EnvironmentSelectors.isPhone);
    const isWebview = yield select(EnvironmentSelectors.isWebview);

    // Открываем левое меню после возвращения со страницы логина на таче.
    if (isPhone && !isWebview && queryParam === 'show-left-menu') {
        yield call(renderMobileLeftMenu, { animated: false });
    }
}
